<!-- Breadcrumb-->
<div class="row pt-2 pb-2">
	<div class="col-sm-9">
		<h4 class="page-title">Form Layouts</h4>
		<ol class="breadcrumb">
			<li class="breadcrumb-item"><a href="javaScript:;">Bulona</a>
			</li>
			<li class="breadcrumb-item"><a href="javaScript:;">Forms</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Form Layouts</li>
		</ol>
	</div>
	<div class="col-sm-3">
		<div ngbDropdown class="btn-group float-sm-right">
			<button type="button" class="btn btn-Outline-danger"><i class="fa fa-cog mr-1"></i> Setting</button>
			<button type="button" class="btn btn-danger" id="dropdownBasic5" ngbDropdownToggle> <span class="caret"></span>
			</button>
			<div ngbDropdownMenu aria-labelledby="dropdownBasic5"> 
        		<a href="javaScript:;" ngbDropdownItem>Action</a>
				<a href="javaScript:;" ngbDropdownItem>Another action</a>
				<a href="javaScript:;" ngbDropdownItem>Something else here</a>
				<div class="dropdown-divider"></div> 
				<a href="javaScript:;" ngbDropdownItem>Separated link</a>
			</div>
		</div>
	</div>
</div>
<!-- End Breadcrumb-->
<div class="row">
	<div class="col-lg-4">
		<div class="card">
			<div class="card-header">Vertical Form</div>
			<div class="card-body">
				<form>
					<div class="form-group">
						<label for="input-1">Name</label>
						<input type="text" class="form-control" id="input-1">
					</div>
					<div class="form-group">
						<label for="input-2">Email</label>
						<input type="text" class="form-control" id="input-2">
					</div>
					<div class="form-group">
						<label for="input-3">Mobile</label>
						<input type="text" class="form-control" id="input-3">
					</div>
					<div class="form-group">
						<label for="input-4">Password</label>
						<input type="text" class="form-control" id="input-4">
					</div>
					<div class="form-group">
						<label for="input-5">Confirm Password</label>
						<input type="text" class="form-control" id="input-5">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-primary">
							<input type="checkbox" id="user-checkbox1" checked="" />
							<label for="user-checkbox1">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-primary px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-4">
		<div class="card">
			<div class="card-header">Round Vertical Form</div>
			<div class="card-body">
				<form>
					<div class="form-group">
						<label for="input-6">Name</label>
						<input type="text" class="form-control form-control-rounded" id="input-6">
					</div>
					<div class="form-group">
						<label for="input-7">Email</label>
						<input type="text" class="form-control form-control-rounded" id="input-7">
					</div>
					<div class="form-group">
						<label for="input-8">Mobile</label>
						<input type="text" class="form-control form-control-rounded" id="input-8">
					</div>
					<div class="form-group">
						<label for="input-9">Password</label>
						<input type="text" class="form-control form-control-rounded" id="input-9">
					</div>
					<div class="form-group">
						<label for="input-10">Confirm Password</label>
						<input type="text" class="form-control form-control-rounded" id="input-10">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-info">
							<input type="checkbox" id="user-checkbox2" checked="" />
							<label for="user-checkbox2">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-info btn-round px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-4">
		<div class="card">
			<div class="card-header">Square Vertical Form</div>
			<div class="card-body">
				<form>
					<div class="form-group">
						<label for="input-11">Name</label>
						<input type="text" class="form-control form-control-square" id="input-11">
					</div>
					<div class="form-group">
						<label for="input-12">Email</label>
						<input type="text" class="form-control form-control-square" id="input-12">
					</div>
					<div class="form-group">
						<label for="input-13">Mobile</label>
						<input type="text" class="form-control form-control-square" id="input-13">
					</div>
					<div class="form-group">
						<label for="input-14">Password</label>
						<input type="text" class="form-control form-control-square" id="input-14">
					</div>
					<div class="form-group">
						<label for="input-15">Confirm Password</label>
						<input type="text" class="form-control form-control-square" id="input-15">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-danger">
							<input type="checkbox" id="user-checkbox3" checked="" />
							<label for="user-checkbox3">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-danger btn-square px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!--End Row-->
<div class="row">
	<div class="col-12 col-lg-12 col-xl-12">
		<div class="card">
			<div class="card-header">Horizontal Form</div>
			<div class="card-body">
				<form>
					<div class="form-group row">
						<label for="input-21" class="col-sm-2 col-form-label">Name</label>
						<div class="col-sm-10">
							<input type="text" class="form-control" id="input-21" placeholder="Enter Your Name">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-22" class="col-sm-2 col-form-label">Email</label>
						<div class="col-sm-10">
							<input type="text" class="form-control" id="input-22" placeholder="Enter Your Email Address">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-23" class="col-sm-2 col-form-label">Mobile</label>
						<div class="col-sm-10">
							<input type="text" class="form-control" id="input-23" placeholder="Enter Your Mobile Number">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-24" class="col-sm-2 col-form-label">Password</label>
						<div class="col-sm-10">
							<input type="text" class="form-control" id="input-24" placeholder="Enter Password">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-25" class="col-sm-2 col-form-label">Confirm Password</label>
						<div class="col-sm-10">
							<input type="text" class="form-control" id="input-25" placeholder="Confirm Password">
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-2 col-form-label"></label>
						<div class="col-sm-10">
							<div class="icheck-material-secondary">
								<input type="checkbox" id="user-checkbox5" checked="" />
								<label for="user-checkbox5">Remember me</label>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-2 col-form-label"></label>
						<div class="col-sm-10">
							<button type="submit" class="btn btn-secondary px-5"><i class="icon-lock"></i> Register</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="card">
			<div class="card-header">Round Horizontal Form</div>
			<div class="card-body">
				<form>
					<div class="form-group row">
						<label for="input-26" class="col-sm-2 col-form-label">Name</label>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-rounded" id="input-26" placeholder="Enter Your Name">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-27" class="col-sm-2 col-form-label">Email</label>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-rounded" id="input-27" placeholder="Enter Your Email Address">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-28" class="col-sm-2 col-form-label">Mobile</label>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-rounded" id="input-28" placeholder="Enter Your Mobile Number">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-29" class="col-sm-2 col-form-label">Password</label>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-rounded" id="input-29" placeholder="Enter Password">
						</div>
					</div>
					<div class="form-group row">
						<label for="input-30" class="col-sm-2 col-form-label">Confirm Password</label>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-rounded" id="input-30" placeholder="Confirm Password">
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-2 col-form-label"></label>
						<div class="col-sm-10">
							<div class="icheck-material-dark">
								<input type="checkbox" id="user-checkbox6" checked="" />
								<label for="user-checkbox6">Remember me</label>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<label class="col-sm-2 col-form-label"></label>
						<div class="col-sm-10">
							<button type="submit" class="btn btn-dark btn-round px-5"><i class="icon-lock"></i> Register</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!--End Row-->
<h6 class="text-uppercase">Color Forms</h6>
<hr>
<div class="row">
	<div class="col-lg-4">
		<div class="card gradient-primary">
			<div class="card-header border-bottom border-white-2 text-white">Vertical Form</div>
			<div class="card-body">
				<form class="color-forms">
					<div class="form-group">
						<label for="input-31">Name</label>
						<input type="text" class="form-control" id="input-31">
					</div>
					<div class="form-group">
						<label for="input-32">Email</label>
						<input type="text" class="form-control" id="input-32">
					</div>
					<div class="form-group">
						<label for="input-33">Mobile</label>
						<input type="text" class="form-control" id="input-33">
					</div>
					<div class="form-group">
						<label for="input-34">Password</label>
						<input type="text" class="form-control" id="input-34">
					</div>
					<div class="form-group">
						<label for="input-35">Confirm Password</label>
						<input type="text" class="form-control" id="input-35">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-white">
							<input type="checkbox" id="color-checkbox1" checked="" />
							<label for="color-checkbox1">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-gradient-primary border border-white px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-4">
		<div class="card gradient-success">
			<div class="card-header border-bottom border-white-2 text-white">Round Vertical Form</div>
			<div class="card-body">
				<form class="color-forms">
					<div class="form-group">
						<label for="input-36">Name</label>
						<input type="text" class="form-control form-control-rounded" id="input-36">
					</div>
					<div class="form-group">
						<label for="input-37">Email</label>
						<input type="text" class="form-control form-control-rounded" id="input-37">
					</div>
					<div class="form-group">
						<label for="input-38">Mobile</label>
						<input type="text" class="form-control form-control-rounded" id="input-38">
					</div>
					<div class="form-group">
						<label for="input-39">Password</label>
						<input type="text" class="form-control form-control-rounded" id="input-39">
					</div>
					<div class="form-group">
						<label for="input-40">Confirm Password</label>
						<input type="text" class="form-control form-control-rounded" id="input-40">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-white">
							<input type="checkbox" id="color-checkbox2" checked="" />
							<label for="color-checkbox2">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-gradient-success border border-white btn-round px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-4">
		<div class="card gradient-danger">
			<div class="card-header border-white-2 text-white border-bottom">Square Vertical Form</div>
			<div class="card-body">
				<form class="color-forms">
					<div class="form-group">
						<label for="input-41">Name</label>
						<input type="text" class="form-control form-control-square" id="input-41">
					</div>
					<div class="form-group">
						<label for="input-42">Email</label>
						<input type="text" class="form-control form-control-square" id="input-42">
					</div>
					<div class="form-group">
						<label for="input-43">Mobile</label>
						<input type="text" class="form-control form-control-square" id="input-43">
					</div>
					<div class="form-group">
						<label for="input-44">Password</label>
						<input type="text" class="form-control form-control-square" id="input-44">
					</div>
					<div class="form-group">
						<label for="input-45">Confirm Password</label>
						<input type="text" class="form-control form-control-square" id="input-45">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-white">
							<input type="checkbox" id="color-checkbox3" checked="" />
							<label for="color-checkbox3">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-gradient-danger border border-white btn-square px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!--End Row-->
<div class="row">
	<div class="col-lg-4">
		<div class="card gradient-secondary">
			<div class="card-header border-bottom border-white-2 text-white">Vertical Form</div>
			<div class="card-body">
				<form class="color-forms">
					<div class="form-group">
						<label for="input-46">Name</label>
						<input type="text" class="form-control" id="input-46">
					</div>
					<div class="form-group">
						<label for="input-47">Email</label>
						<input type="text" class="form-control" id="input-47">
					</div>
					<div class="form-group">
						<label for="input-48">Mobile</label>
						<input type="text" class="form-control" id="input-48">
					</div>
					<div class="form-group">
						<label for="input-49">Password</label>
						<input type="text" class="form-control" id="input-49">
					</div>
					<div class="form-group">
						<label for="input-50">Confirm Password</label>
						<input type="text" class="form-control" id="input-50">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-white">
							<input type="checkbox" id="color-checkbox4" checked="" />
							<label for="color-checkbox4">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-gradient-secondary border border-white px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-4">
		<div class="card bg-dark">
			<div class="card-header border-bottom border-white-3 text-white">Round Vertical Form</div>
			<div class="card-body">
				<form class="color-forms">
					<div class="form-group">
						<label for="input-51">Name</label>
						<input type="text" class="form-control form-control-rounded" id="input-51">
					</div>
					<div class="form-group">
						<label for="input-52">Email</label>
						<input type="text" class="form-control form-control-rounded" id="input-52">
					</div>
					<div class="form-group">
						<label for="input-53">Mobile</label>
						<input type="text" class="form-control form-control-rounded" id="input-53">
					</div>
					<div class="form-group">
						<label for="input-54">Password</label>
						<input type="text" class="form-control form-control-rounded" id="input-54">
					</div>
					<div class="form-group">
						<label for="input-55">Confirm Password</label>
						<input type="text" class="form-control form-control-rounded" id="input-55">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-white">
							<input type="checkbox" checked="" id="color-checkbox5" />
							<label for="color-checkbox5">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-white btn-round px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-4">
		<div class="card gradient-warning">
			<div class="card-header border-white-2 border-bottom text-white">Square Vertical Form</div>
			<div class="card-body">
				<form class="color-forms">
					<div class="form-group">
						<label for="input-56">Name</label>
						<input type="text" class="form-control form-control-square" id="input-56">
					</div>
					<div class="form-group">
						<label for="input-57">Email</label>
						<input type="text" class="form-control form-control-square" id="input-57">
					</div>
					<div class="form-group">
						<label for="input-58">Mobile</label>
						<input type="text" class="form-control form-control-square" id="input-58">
					</div>
					<div class="form-group">
						<label for="input-59">Password</label>
						<input type="text" class="form-control form-control-square" id="input-59">
					</div>
					<div class="form-group">
						<label for="input-60">Confirm Password</label>
						<input type="text" class="form-control form-control-square" id="input-60">
					</div>
					<div class="form-group py-2">
						<div class="icheck-material-white">
							<input type="checkbox" checked="" id="color-checkbox6" />
							<label for="color-checkbox6">I Agree Terms & Conditions</label>
						</div>
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-gradient-warning border border-white btn-square px-5"><i class="icon-lock"></i> Register</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!--End Row-->